var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "campaign-list-page" },
    [
      _c("campaign-table", {
        ref: "table",
        attrs: { url: _vm.indexUrl },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function () {
              return [
                _vm.canCreate
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "New",
                          effect: "light",
                          placement: "top-start",
                          "open-delay": 300,
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-purple",
                            on: { click: _vm.addCampaign },
                          },
                          [_c("i", { staticClass: "far fa-file" })]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canIndexTemplate
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "New From Template",
                          effect: "light",
                          placement: "top-start",
                          "open-delay": 300,
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-purple",
                            on: { click: _vm.addFromTemplate },
                          },
                          [_c("i", { staticClass: "fas fa-copy" })]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canPreview
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Schedule messages sending",
                          effect: "light",
                          placement: "top-start",
                          "open-delay": 300,
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-purple",
                            attrs: { href: _vm.previewUrl },
                          },
                          [_c("i", { staticClass: "fas fa-calendar-check" })]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("dialog-form-wrapper"),
      _vm._v(" "),
      _c("dialog-campaign-templates-table", {
        attrs: { url: _vm.templateIndexUrl },
        on: { select: _vm.onTemplateSelect },
      }),
      _vm._v(" "),
      _c("dialog-view-wrapper"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }